import React from "react";
import { Button, Card, Form, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Label } from "reactstrap";

function Step4() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  // console.log(valDetail, "LLLLLLLLLL");

  return (
    <div className="mt-4">
      <h4
        style={{
          fontWeight: "800",
          textTransform: "uppercase",
          color: "#2C3E50",
          fontSize: "18px",
          marginBottom: "20px",
          paddingBottom: "12px",
          borderBottom: "2px solid #f0f0f0"
        }}
      >
        Informasi Pinjaman
      </h4>
      <div style={{ maxHeight: "550px", overflowY: "auto", overflowX: "hidden", padding: "5px" }}>
        <Row>
          {[
            {
              label: "tujuan penggunaan",
              value:
                valDetail?.stepEmpat?.tujuanPenggunaan === "3"
                  ? "Konsumtif"
                  : valDetail?.stepEmpat?.tujuanPenggunaan
                    ? "Produktif"
                    : null,
            },
            {
              label: "jenis kredit",
              value:
                {
                  "01": "Multiguna Utama",
                  "02": "Multiguna Pensiunan",
                  "03": "Multiguna Kretap",
                  "04": "Multiguna Terusan",
                }[valDetail?.stepEmpat?.jenisKredit] ||
                (valDetail?.stepEmpat?.jenisKredit
                  ? "Multiguna Plus"
                  : null),
            },
            { label: "tenor", value: valDetail?.stepEmpat?.tenor },
            {
              label: "nominal permohonan",
              value: valDetail?.stepEmpat?.nominalPermohonan
                ? `Rp ${valDetail.stepEmpat.nominalPermohonan.toLocaleString("id-ID")}`
                : null,
            },
            {
              label: "nominal pencairan",
              value: valDetail?.nominalPencairan
                ? `Rp ${valDetail.nominalPencairan.toLocaleString("id-ID")}`
                : null,
            },
            { label: "nip", value: valDetail?.stepEmpat?.nip },
            {
              label: "suku bunga",
              value: valDetail?.stepEmpat?.sukuBunga
                ? `${valDetail.stepEmpat.sukuBunga}%`
                : null,
            },
            {
              label: "detail tujuan penggunaan",
              value: valDetail?.stepEmpat?.detailTujuanPenggunaan,
            },
            {
              label: "status pinjaman",
              value:
                {
                  1: "New",
                  2: "Top Up",
                  3: "Kompensasi",
                  4: "Take Over",
                }[valDetail?.stepEmpat?.statusPinjaman] ||
                (valDetail?.stepEmpat?.statusPinjaman
                  ? "Pelunasan Di Pengajuan"
                  : null),
            },
            {
              label: "cabang pencairan",
              value: valDetail?.lokasiPencairan?.namaCabang,
            },
            {
              label: "pembayaran gaji melalui",
              value:
                {
                  1: "PT BPD KALTIMTARA",
                  2: "Bendahara",
                  3: "Koperasi",
                  4: "Bank Lain",
                }[valDetail?.stepEmpat?.pembayaranGajiMelalui] ||
                (valDetail?.stepEmpat?.pembayaranGajiMelalui
                  ? "Lainnya"
                  : null),
            },
            {
              label: "alamat cabang",
              value: valDetail?.lokasiPencairan?.alamat,
            },
          ].map((item, index) => (
            <Col xs={12} sm={6} lg={4} key={index} className="mb-3">
              <div 
                style={{ 
                  padding: "16px 20px", 
                  backgroundColor: "#F8FAFC", 
                  borderRadius: "14px", 
                  height: "100%", 
                  border: "1px solid #E2E8F0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#F0F9FF";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(14, 165, 233, 0.12)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.borderColor = "#BAE6FD";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F8FAFC";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#E2E8F0";
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#64748B",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px"
                  }}
                >
                  {item.label}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#1E293B",
                    fontWeight: "600",
                    textTransform: "capitalize",
                    wordBreak: "break-word",
                    lineHeight: "1.4"
                  }}
                >
                  {item.value !== null && item.value !== undefined && item.value !== "" ? item.value : <span style={{ color: "#CBD5E1" }}>-</span>}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
export default Step4;
